/**
 * @voltxampere/ui — 4051 8-channel analog mux CMOS variant (Sprint 43-6, full simulation)
 *
 * Sprint 41-5 shipped this as a placeholder against the digital-gate
 * stamp. Sprint 43 ADR-0063 introduced the dedicated `analog-mux-8`
 * canonical engine type — the variant now points there and routes
 * the selected analog channel to the common output via the new DC
 * stamp. Drag-drop, schema persistence, F5 simulate all live.
 *
 * Reference: TI CD4051B. 8 analog input channels (CH0..CH7), 3 binary
 * select pins (A/B/C), active-LOW INH (Inhibit / chip-enable). Vcc 3-15 V.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic4051 = {
    id: "4051",
    nameTr: "4051 (8 Kanal Analog Mux CMOS, DIP-16)",
    nameEn: "4051 (8-Channel Analog Mux CMOS, DIP-16)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "4051",
    schemaType: "analog-mux-8",
    defaultParams: {
        channelCount: 8,
        threshold: 2.5,
        enableActiveLow: true,
        rOn: 100,
        propagationDelay: 100e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-4051.js.map